<template>
  <div>
    <div
      v-if="loading"
      class="text-center py-8"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      ></v-progress-circular>
    </div>

    <template v-else-if="setup">
      <p class="text-sm mb-2">
        1. افتح تطبيق المصادقة وامسح رمز QR، او ادخل المفتاح يدويا:
      </p>

      <div class="text-center mb-4">
        <img
          v-if="qr"
          :src="qr"
          alt="QR"
          width="200"
          height="200"
        />
      </div>

      <v-text-field
        :value="setup.secret"
        readonly
        dense
        outlined
        hide-details
        class="mb-4 totp-secret"
        :append-icon="icons.mdiContentCopy"
        @click:append="copySecret"
      ></v-text-field>

      <p class="text-sm mb-2">
        2. ادخل الرمز المكون من {{ setup.digits }} ارقام الظاهر في التطبيق:
      </p>

      <otp-input
        ref="otp"
        v-model="code"
        :length="setup.digits || 6"
        :disabled="confirming"
        autofocus
        class="mb-6"
        @complete="confirm"
      />

      <div :class="block ? '' : 'text-end'">
        <v-btn
          color="primary"
          :block="block"
          :loading="confirming"
          :disabled="confirming || !complete"
          @click="confirm"
        >
          تأكيد وتفعيل
        </v-btn>
        <v-btn
          v-if="cancelable"
          text
          class="ms-2"
          :disabled="confirming"
          @click="$emit('cancel')"
        >
          الغاء
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mdiContentCopy } from '@mdi/js'
import Qrious from 'qrious'
import axios from '@axios'
import toast from '@/store/toast'
import OtpInput from '@/components/OtpInput.vue'

export default {
  name: 'TotpEnrollment',
  components: { OtpInput },
  props: {
    // show a cancel button next to the confirm one
    cancelable: {
      type: Boolean,
      default: false,
    },

    // full width confirm button, for the narrow setup page
    block: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    loading: true,
    confirming: false,
    setup: null,
    qr: null,
    code: '',
    icons: { mdiContentCopy },
  }),
  computed: {
    complete() {
      return this.code.length === ((this.setup && this.setup.digits) || 6)
    },
  },
  async mounted() {
    await this.start()
  },
  methods: {
    async start() {
      this.loading = true
      try {
        const { data: response } = await axios.post('/auth/totp/setup')
        this.setup = response.data
        this.qr = new Qrious({
          level: 'H',
          size: 400,
          value: response.data.otpauth_uri,
        }).toDataURL('image/png')
      } catch (error) {
        // the axios interceptor already surfaced the message
        this.$emit('failed')
      } finally {
        this.loading = false
      }
    },
    async confirm() {
      // the boxes submit on their own once full, so a click landing at the same
      // moment must not fire a second request: the server would answer the
      // duplicate with "already enabled"
      if (this.confirming || !this.complete) {
        return
      }
      this.confirming = true
      try {
        const { data: response } = await axios.post('/auth/totp/confirm', { code: this.code })
        this.$emit('enrolled', response.data)
      } catch (error) {
        // a rejected code leaves the boxes empty and ready for the next one
        this.code = ''
        if (this.$refs.otp) {
          this.$refs.otp.clear()
        }
      } finally {
        this.confirming = false
      }
    },
    async copySecret() {
      try {
        await navigator.clipboard.writeText(this.setup.secret)
        await toast.dispatch('success', 'تم نسخ المفتاح.')
      } catch (error) {
        await toast.dispatch('error', 'لم يتم النسخ، يرجى النسخ يدويا.')
      }
    },
  },
}
</script>

<style scoped>
.totp-secret ::v-deep input {
  letter-spacing: 2px;
}
</style>
